module.exports = __webpack_public_path__ + "static/media/ic_chevron-down.e253b42f.svg";